import { useCallback, useEffect, useRef } from 'preact/hooks';

export const useAbortController = () => {
  const abortControllerRef = useRef<AbortController | undefined>();

  useEffect(() => {
    const controller = abortControllerRef.current;

    return () => controller?.abort();
  }, []);

  const getSignal = useCallback(() => {
    if (!abortControllerRef.current) {
      try {
        abortControllerRef.current = new AbortController();
      } catch {
        // :sadge:
      }
    }

    return abortControllerRef.current?.signal;
  }, []);

  return { getSignal };
};
